import {Pipe, PipeTransform} from '@angular/core';
import {FolderDto} from '../../../Models/Rrhh/Folders/folder.interface';

@Pipe({
  name: 'folders',
  standalone: false
})
export class FoldersPipe implements PipeTransform {

  transform(items: FolderDto[], filter: { id_local?: number, id_departamento?: number }): FolderDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.id_local) {
      items = items.filter((item) => item.id_local === filter.id_local || !item.id_local);
    }

    if (filter.id_departamento) {
      items = items.filter((item) => item.id_departamento === filter.id_departamento || !item.id_departamento);
    }

    return items;

  }

}
